import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

type listWasteStreamsResponse = {
  wasteStreams: string[];
};

export const listWasteStreams = async () => {
  const response = await executeApiRequest(() => axios.get<listWasteStreamsResponse>("/requests/wastestreams"));
  return response?.data.wasteStreams ?? [];
};
